
export default [
    {
        "id": 1,
        "shikenId": 3,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険募集人の登録を受けていないファイナンシャル・プランナーが、ライフプランの相談に来た顧客に対し、生命保険商品の一般的な商品性について説明することは、保険業法において禁止されている。(2023.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 2,
        "shikenId": 3,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "労働者災害補償保険の保険料は、労働者と事業主が折半で負担する。(2024.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 3,
        "shikenId": 3,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "老齢厚生年金の繰上げ支給の請求は、老齢基礎年金の繰上げ支給の請求と同時に行わなければならない。(2021.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 4,
        "shikenId": 3,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "国民年金基金の給付には、老齢年金と遺族一時金がある。(2024.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 5,
        "shikenId": 3,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "住宅ローンの一部繰上げ返済では、返済期間を変更せずに毎月の返済額を減額する返済額軽減型よりも、毎月の返済額を変更せずに返済期間を短くする期間短縮型のほうが、他の条件が同一である場合、通常、総返済額は少なくなる。(2023.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 6,
        "shikenId": 3,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "払済保険とは、一般に、現在契約している生命保険の保険料の払込みを中止し、その時点での解約返戻金相当額を基に、元の契約の保険金額を変えずに一時払いの定期保険に変更する制度である。(2024.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 7,
        "shikenId": 3,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "こども保険（学資保険）において、保険期間中に契約者（＝保険料負担者）である親が死亡した場合、一般に、既払込保険料相当額の死亡保険金が支払われて契約は消滅する。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 8,
        "shikenId": 3,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "変額個人年金保険は、特別勘定の運用実績によって、将来受け取る年金額や死亡給付金額は変動するが、解約返戻金額は変動しない。(2023.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 9,
        "shikenId": 3,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "製造した食品が原因で食中毒を発生させ、顧客の身体に損害を与えたことにより、法律上の損害賠償責任を負うことによって被る損害を補償する保険として、生産物賠償責任保険（PL保険）がある。(2201.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 10,
        "shikenId": 3,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "がん保険では、一般に、責任開始日前に90日程度の免責期間が設けられており、その期間中にがんと診断されたとしても、がん診断給付金は支払われない。(2022.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 11,
        "shikenId": 3,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "日本銀行の金融政策の1つである公開市場操作（オペレーション）のうち、国債買入オペは、日本銀行が長期国債（利付国債）を買い入れることによって金融市場から資金を吸収するオペレーションである。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 12,
        "shikenId": 3,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "公社債投資信託は、投資対象に株式をいっさい組み入れることができない。(2021.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 13,
        "shikenId": 3,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "一般に、残存期間や表面利率（クーポンレート）が同一であれば、格付の高い債券ほど利回りが低く、格付の低い債券ほど利回りが高くなる。(2023.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 14,
        "shikenId": 3,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "日経平均株価は、東京証券取引所スタンダード市場に上場している代表的な225銘柄を対象として算出される。(2023.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 15,
        "shikenId": 3,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "国内銀行に預け入れられた外貨預金は、預金保険制度の保護の対象となる。(2019.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 16,
        "shikenId": 3,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、交通機関を利用して通勤している給与所得者に対し、勤務先から通常の給与に加算して支払われるべき通勤手当は、最も経済的かつ合理的と認められる運賃等の額で、月額15万円を限度に非課税とされる。(2019.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 17,
        "shikenId": 3,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、事業的規模で行われている賃貸マンションの貸付による所得は、事業所得となる。(2022.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 18,
        "shikenId": 3,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、一時所得の金額は、その年中の一時所得に係る総収入金額からその収入を得るために直接支出した金額の合計額を控除し、その残額から特別控除額（最高50万円）を控除した金額であり、その金額が総所得金額に算入される。(2020.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 19,
        "shikenId": 3,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税法上、控除対象扶養親族のうち、その年の12月31日現在の年齢が70歳以上の者は、老人扶養親族に該当する。(2021.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 20,
        "shikenId": 3,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "給与所得者が所得税の住宅借入金等特別控除の適用を受ける場合、その適用を受ける最初の年分については、年末調整の対象者であっても、確定申告をしなければならない。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 21,
        "shikenId": 3,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産登記には公信力が認められていないため、登記記録上の権利者が真実の権利者と異なっている場合に、登記記録を信じて不動産を購入した者は、原則として、その不動産に対する権利の取得について法的に保護されない。(2023.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 22,
        "shikenId": 3,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画法において、市街化区域内で行う開発行為は、その規模にかかわらず、都道府県知事等の許可を受けなければならない。(2023.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 23,
        "shikenId": 3,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "建築基準法において、建築物が防火地域および準防火地域にわたる場合、原則として、その全部について防火地域内の建築物に関する規定が適用される。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 24,
        "shikenId": 3,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "贈与や相続により不動産を取得した場合、不動産取得税は課されない。(2024.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 25,
        "shikenId": 3,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "「被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例」の適用を受けるためには、譲渡の対価の額が5,000万円以下でなければならない。(2020.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 26,
        "shikenId": 3,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "書面によらない贈与契約は、既に履行が終わった部分を除き、各当事者が解除をすることができる。(2021.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 27,
        "shikenId": 3,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "贈与税の納付については、納期限までに金銭で納付することを困難とする事由があるなど、所定の要件を満たせば、延納または物納によることが認められている。(2019.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 28,
        "shikenId": 3,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税の申告書の提出は、原則として、その相続の開始があったことを知った日の翌日から10カ月以内にしなければならない。(2023.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 29,
        "shikenId": 3,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "被相続人の葬式後に相続人が負担した香典返戻費用は、相続税額の計算上、葬式費用として債務控除の対象となる。(2024.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 30,
        "shikenId": 3,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続人が相続により取得した宅地が「小規模宅地等についての相続税の課税価格の計算の特例」における特定居住用宅地等に該当する場合、その宅地のうち330㎡までを限度面積として、評価額の80％相当額を減額した金額を、相続税の課税価格に算入すべき価額とすることができる。(2023.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 31,
        "shikenId": 3,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "Aさんの可処分所得（年間）の金額は、下記の〈資料〉によれば、（ ）である。<br> <br> 〈資料〉Aさんの年間収入等<br> ・給与収入：800万円（給与所得：610万円）<br> ・所得税・住民税：60万円<br> ・社会保険料：100万円<br> ・生命保険料：10万円(2025.05)",
        "choice1": "450万円",
        "choice2": "630万円",
        "choice3": "640万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 32,
        "shikenId": 3,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "全国健康保険協会管掌健康保険の被保険者に支給される傷病手当金の額は、1日につき、原則として、傷病手当金の支給を始める日の属する月以前の直近の継続した（①）の各月の標準報酬月額の平均額を30で除した額に、（②）を乗じた額である。(2021.01)",
        "choice1": "① 12カ月間　　② 3分の2",
        "choice2": "① 12カ月間　　② 4分の3",
        "choice3": "① 6カ月間　　② 5分の4",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 33,
        "shikenId": 3,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "雇用保険の基本手当を受給するためには、倒産、解雇および雇止めなどの場合を除き、原則として、離職の日以前（①）に被保険者期間が通算して（②）以上あることなどの要件を満たす必要がある。(2022.09)",
        "choice1": "① 1年間　　② 6カ月",
        "choice2": "① 2年間　　② 6カ月",
        "choice3": "① 2年間　　② 12カ月",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 34,
        "shikenId": 3,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "遺族厚生年金の額（中高齢寡婦加算額および経過的寡婦加算額を除く）は、原則として、死亡した者の厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の（ ）に相当する額である。(2022.01)",
        "choice1": "2分の1",
        "choice2": "3分の2",
        "choice3": "4分の3",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 35,
        "shikenId": 3,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "貸金業法の総量規制により、個人が貸金業者による個人向け貸付を利用する場合の借入合計額は、原則として、年収の（ ）以内でなければならない。(2023.05)",
        "choice1": "2分の1",
        "choice2": "3分の1",
        "choice3": "4分の1",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 36,
        "shikenId": 3,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険契約の契約者は、契約者貸付制度を利用することにより、契約している生命保険の（ ）の一定の範囲内で保険会社から貸付を受けることができる。(2023.01)",
        "choice1": "既払込保険料総額",
        "choice2": "解約返戻金額",
        "choice3": "死亡保険金額",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 37,
        "shikenId": 3,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "生命保険契約において、契約者（＝保険料負担者）が夫、被保険者が（①）、死亡保険金受取人が（②）である場合、被保険者の死亡により死亡保険金受取人が受け取る死亡保険金は、相続税の課税対象となる。(2021.09)",
        "choice1": "① 妻　　② 夫",
        "choice2": "① 妻　　② 子",
        "choice3": "① 夫　　② 子",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 38,
        "shikenId": 3,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "スーパーマーケットを経営する企業が、火災により店舗が全焼し、休業した場合の利益損失を補償する保険として、（ ）がある。(2023.09)",
        "choice1": "請負業者賠償責任保険",
        "choice2": "企業費用・利益総合保険",
        "choice3": "施設所有（管理）者賠償責任保険",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 39,
        "shikenId": 3,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "民法および失火の責任に関する法律（失火責任法）において、借家人が軽過失によって火事を起こし、借家と隣家を焼失させた場合、借家の家主に対して損害賠償責任を（①）。また、隣家の所有者に対して損害賠償責任を（②）。(2022.01)",
        "choice1": "① 負う　　② 負わない",
        "choice2": "① 負う　　② 負う",
        "choice3": "① 負わない　　② 負う",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 40,
        "shikenId": 3,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、個人が支払う地震保険の保険料に係る地震保険料控除は、原則として、（①）を限度として年間支払保険料の（②）が控除額となる。(2022.05)",
        "choice1": "① 5万円　　② 全額",
        "choice2": "① 5万円　　② 2分の1相当額",
        "choice3": "① 10万円　　② 2分の1相当額",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 41,
        "shikenId": 3,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "投資信託の運用において、企業の成長性が市場平均よりも高いと見込まれる銘柄に投資する手法を、（ ）という。(2023.01)",
        "choice1": "パッシブ運用",
        "choice2": "バリュー運用",
        "choice3": "グロース運用",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 42,
        "shikenId": 3,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "2024年以降にNISAの「成長投資枠」を利用して上場株式を購入することができる限度額（年間投資枠）は、年間（ ）である。(2024.05)",
        "choice1": "102万円",
        "choice2": "120万円",
        "choice3": "240万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 43,
        "shikenId": 3,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "上場企業X社の下記の＜資料＞に基づいて計算したX社株式の株価収益率（PER）は（①）、株価純資産倍率（PBR）は（②）である。(2021.01)<br><img src='/img/43_0416.png' style='width:300px !important'>",
        "choice1": "① 1.5倍　　② 15倍",
        "choice2": "① 10倍　　② 1.5倍",
        "choice3": "① 15倍　　② 1.5倍",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 44,
        "shikenId": 3,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "為替予約を締結していない外貨定期預金において、満期時の為替レートが預入時の為替レートに比べて（①）になれば、当該外貨定期預金の円換算の利回りは（②）なる。(2022.09)",
        "choice1": "① 円高　　② 高く",
        "choice2": "① 円安　　② 高く",
        "choice3": "① 円安　　② 低く",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 45,
        "shikenId": 3,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "A資産の期待収益率が3.0％、B資産の期待収益率が5.0％の場合に、A資産を40％、B資産を60％の割合で組み入れたポートフォリオの期待収益率は、（ ）となる。(2023.5)",
        "choice1": "1.8％",
        "choice2": "4.0％",
        "choice3": "4.2％",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 46,
        "shikenId": 3,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が土地を譲渡したことによる譲渡所得の金額の計算において、譲渡した土地の取得費が不明である場合、当該収入金額の（ ）相当額を取得費とすることができる。(2022.01)",
        "choice1": "5％",
        "choice2": "10％",
        "choice3": "15％",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 47,
        "shikenId": 3,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税において、不動産所得、（ ）、山林所得、譲渡所得の金額の計算上生じた損失の金額は、一定の場合を除き、他の所得の金額と損益通算することができる。(2022.01)",
        "choice1": "一時所得",
        "choice2": "雑所得",
        "choice3": "事業所得",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 48,
        "shikenId": 3,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "納税者が2012年1月1日以後に締結した生命保険契約により、一般の生命保険料控除の対象となる保険料、個人年金保険料控除の対象となる保険料および介護医療保険料控除の対象となる保険料をそれぞれ年間10万円支払った場合、所得税において、支払った年分の生命保険料控除の控除額は、（ ）となる。(2024.05)",
        "choice1": "12万円",
        "choice2": "15万円",
        "choice3": "30万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 49,
        "shikenId": 3,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税において、確定拠出年金の個人型年金の掛金で、加入者本人が支払ったものは、（ ）の対象となる。(2023.01)",
        "choice1": "生命保険料控除",
        "choice2": "社会保険料控除",
        "choice3": "小規模企業共済等掛金控除",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 50,
        "shikenId": 3,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "年末調整の対象となる給与所得者は、所定の手続により、年末調整で所得税の（ ）の適用を受けることができる。(2024.01)",
        "choice1": "雑損控除",
        "choice2": "寄附金控除",
        "choice3": "小規模企業共済等掛金控除",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 51,
        "shikenId": 3,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税路線価は、相続税や（①）を算定する際の土地等の評価額の基準となる価格であり、地価公示法による公示価格の（②）を価格水準の目安として設定される。(2023.09)",
        "choice1": "① 贈与税　　② 70％",
        "choice2": "① 贈与税　　② 80％",
        "choice3": "① 固定資産税　　② 80％",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 52,
        "shikenId": 3,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "宅地建物取引業法上の媒介契約のうち、（①）では、依頼者は他の宅地建物取引業者に重ねて媒介の依頼をすることができるが、（②）では、依頼者は他の宅地建物取引業者に重ねて媒介の依頼をすることが禁じられている。(2021.09)",
        "choice1": "① 一般媒介契約　　② 専任媒介契約",
        "choice2": "① 専任媒介契約　　② 一般媒介契約",
        "choice3": "① 専任媒介契約　　② 専属専任媒介契約",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 53,
        "shikenId": 3,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域内にある幅員4ｍ未満の道で、建築基準法第42条第2項により道路とみなされるものについては、原則として、その中心線からの水平距離で（ ）後退した線がその道路の境界線とみなされる。(2022.01)",
        "choice1": "2ｍ",
        "choice2": "3ｍ",
        "choice3": "4ｍ",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 54,
        "shikenId": 3,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律（区分所有法）によれば、集会においては、区分所有者および議決権の各（ ）以上の多数により、区分所有建物を取り壊し、その敷地上に新たに建物を建築する旨の決議（建替え決議）をすることができる。(2023.01)",
        "choice1": "3分の2",
        "choice2": "4分の3",
        "choice3": "5分の4",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 55,
        "shikenId": 3,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "土地の有効活用において、一般に、土地所有者が入居予定の事業会社から建設資金を借り受けて、事業会社の要望に沿った店舗等を建設し、その店舗等を事業会社に賃貸する手法を、（ ）という。(2022.05)",
        "choice1": "等価交換方式",
        "choice2": "建設協力金方式",
        "choice3": "事業用定期借地権方式",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 56,
        "shikenId": 3,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人が死因贈与によって取得した財産は、課税の対象とならない財産を除き、（ ）の課税対象となる。(2022.05)",
        "choice1": "贈与税",
        "choice2": "相続税",
        "choice3": "所得税",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 57,
        "shikenId": 3,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "「直系尊属から結婚・子育て資金の一括贈与を受けた場合の贈与税の非課税」の適用を受ける場合、贈与税が非課税となる金額は、受贈者1人につき最大（ ）である。(2022.09)",
        "choice1": "1,000万円",
        "choice2": "1,500万円",
        "choice3": "2,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 58,
        "shikenId": 3,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "下記の＜親族関係図＞において、遺留分を算定するための財産の価額が2億4,000万円である場合、長女Eさんの遺留分の金額は、（ ）となる。(2023.05)<br><img src='/img/58_0416.jpg'>",
        "choice1": "1,000万円",
        "choice2": "2,000万円",
        "choice3": "4,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 59,
        "shikenId": 3,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "公正証書遺言は、証人2人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がそれを筆記して作成される遺言であり、相続開始後に（①）における検認手続が（②）である。(2022.05)",
        "choice1": "① 公証役場　　② 必要",
        "choice2": "① 家庭裁判所　　② 必要",
        "choice3": "① 家庭裁判所　　② 不要",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 60,
        "shikenId": 3,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "死亡したAさんが所有していた上場株式Xを相続により取得した場合の1株当たりの相続税評価額は、下記の〈資料〉によれば、（ ）である。(2024.05)<br> <br> 〈資料〉上場株式Xの価格<br>  Aさんが死亡した月の前々月の毎日の最終価格の月平均額 ：540円<br>  Aさんが死亡した月の前月の毎日の最終価格の月平均額 ：600円<br>  Aさんが死亡した月の毎日の最終価格の月平均額 ：620円<br>  Aさんが死亡した日の最終価格 ： 600円",
        "choice1": "540円",
        "choice2": "600円",
        "choice3": "620円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 61,
        "shikenId": 4,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/setsu_61.png'/>",
        "question2": "はじめに、Ｍさんは、《設例》の＜Ａさんに関する資料＞に基づき、Ａさんが老齢基礎年金の受給を65歳から開始した場合の年金額を試算した。Ｍさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。なお、老齢基礎年金の年金額は、2026年度価額に基づいて計算するものとする。",
        "choice1": "<img style='width:200px !important' data-image-id=\"I1\" data-asset-id=\"87eac5ca-86ce-4986-b809-ae0b044992b5\" src='/img/4_1_1776230754323376.png' />",
        "choice2": "<img style='width:200px !important' data-image-id=\"I2\" data-asset-id=\"27a5ea23-f0d3-429d-a969-b9a5fe7247b5\" src='/img/4_1_1776230754435980.png' />",
        "choice3": "<img data-image-id=\"I3\" style='width:300px !important' data-asset-id=\"51c980cc-0c75-4ba3-90c1-2aa9ec0b4934\" src='/img/4_1_1776230754599044.png' />",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の年金額",
        "important": ""
    },
    {
        "id": 62,
        "shikenId": 4,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/setsu_61.png'/>",
        "question2": "次に、Ｍさんは、国民年金基金について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-id=\"90869e66-955f-40d6-832c-08a784dc7772\" src='/img/4_2_1776230754681372.png' />",
        "choice1": "① 確定 ② 68,000円 ③ 小規模企業共済等掛金控除",
        "choice2": "① 終身 ② 30,000円 ③ 小規模企業共済等掛金控除",
        "choice3": "① 終身 ② 68,000円 ③ 社会保険料控除",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "ライフ",
        "rontenName": "国民年金基金",
        "important": ""
    },
    {
        "id": 63,
        "shikenId": 4,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/setsu_61.png'/>",
        "question2": "最後に、Ｍさんは、老後の年金収入を増やすことができる各種制度について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「国民年金の付加年金は、月額200円の付加保険料を納付することにより、老齢基礎年金と併せて受給することができる年金です」",
        "choice2": "「確定拠出年金の個人型年金は、加入者自身が掛金の運用方法を選択し、資産を形成する年金制度です。将来受け取ることができる年金額は、運用実績により増減します」",
        "choice3": "「小規模企業共済制度は、個人事業主が廃業等した場合に必要となる資金を準備しておくための制度です。毎月の掛金は、1,000円から70,000円の範囲内（500円単位）で選択することができます」",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "ライフ",
        "rontenName": "年金収入を増やす制度",
        "important": ""
    },
    {
        "id": 64,
        "shikenId": 4,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/setsu_64.png'/>",
        "question2": "はじめに、Ｍさんは、Ｘ社株式の投資指標について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「株価の相対的な割高・割安の度合いを判断する指標に、ＰＥＲやＰＢＲがあります。＜Ｘ社に関する資料＞から算出されるＸ社株式のＰＥＲは1.2倍、ＰＢＲは12倍です」",
        "choice2": "「ＰＥＲとＰＢＲは、一般に、どちらも数値が高いほうが株価は割安と判断されますが、何倍程度が妥当であるかを検討する際は、同業他社の数値や過去の傾向と比較するなど、相対的な数値として捉えることが重要です」",
        "choice3": "「株価に対する１株当たりの年間配当金の割合を示す指標を配当利回りといいます。＜Ｘ社に関する資料＞から算出されるＸ社株式の配当利回りは2.5％です」",
        "choice4": "",
        "choice5": "2022.05改",
        "categoryName": "金融",
        "rontenName": "投資指標",
        "important": ""
    },
    {
        "id": 65,
        "shikenId": 4,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/setsu_64.png'/>",
        "question2": "次に、Ｍさんは、Ｙ投資信託の購入に係る費用等について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ｙ投資信託の購入時に手数料はかかりません。ＮＩＳＡつみたて投資枠の対象となる公募株式投資信託は、購入時手数料がゼロであることが要件の１つとなっています」",
        "choice2": "「運用管理費用（信託報酬）は、投資信託を保有する投資家が間接的に負担する費用です。一般に、Ｙ投資信託のようなインデックス型投資信託は、アクティブ型投資信託よりも運用管理費用（信託報酬）が高い傾向があります」",
        "choice3": "「信託財産留保額は、投資信託の組入資産を売却する際に発生する手数料等を、投資信託を換金する投資家に負担してもらうことを目的として設けられているものですが、Ｙ投資信託では、この費用はかかりません」",
        "choice4": "",
        "choice5": "2022.05改",
        "categoryName": "金融",
        "rontenName": "投資信託のコスト",
        "important": ""
    },
    {
        "id": 66,
        "shikenId": 4,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/setsu_64.png'/>",
        "question2": "最後に、Ｍさんは、ＮＩＳＡの「つみたて投資枠」についてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も適切なものはどれか。",
        "choice1": "「つみたて投資枠の対象となる金融商品は、長期の積立・分散投資に適した一定の商品性を有する公募株式投資信託やＥＴＦとされ、上場株式は対象となっていません」",
        "choice2": "「つみたて投資枠の年間の非課税投資枠は120万円です。購入は累積投資契約に基づく定期かつ継続的な買付けを行う方法に限られており、非課税期間は10年間です」",
        "choice3": "「つみたて投資枠を利用して購入した公募株式投資信託を解約した際に損失が生じた場合、その損失の金額は、特定口座で保有する上場株式等の譲渡益と通算することができます」",
        "choice4": "",
        "choice5": "2022.05改",
        "categoryName": "金融",
        "rontenName": "NISAつみたて投資枠",
        "important": ""
    },
    {
        "id": 67,
        "shikenId": 4,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/setsu_67.png'/>",
        "question2": "Ａさんの2026年分の所得税における総所得金額として、次のうち最も適切なものはどれか。",
        "choice1": "536万円",
        "choice2": "561万円",
        "choice3": "611万円",
        "choice4": "",
        "choice5": "2025.05改",
        "categoryName": "タックス",
        "rontenName": "総所得金額",
        "important": ""
    },
    {
        "id": 68,
        "shikenId": 4,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/setsu_67.png'/>",
        "question2": "所得税の確定申告に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><br>「給与所得者のうち、その年分の給与収入の金額が（ ① ）万円を超える者は、勤務先における年末調整の対象とならないため、原則として、所得税の確定申告をしなければなりません。<br>Ａさんの場合、2026年分の給与収入は（ ① ）万円を超えていませんが、給与所得および退職所得以外の所得金額が（ ② ）万円を超えているため、所得税の確定申告をしなければなりません。所得税の確定申告書は、Ａさんの（ ③ ）を所轄する税務署長に提出することになります」",
        "choice1": "① 1,000　　② 20　　③ 勤務地",
        "choice2": "① 1,000　　② 10　　③ 住所地",
        "choice3": "① 2,000　　② 20　　③ 住所地",
        "choice4": "",
        "choice5": "2025.05改",
        "categoryName": "タックス",
        "rontenName": "所得税の確定申告",
        "important": ""
    },
    {
        "id": 69,
        "shikenId": 4,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/setsu_67.png'/>",
        "question2": "Ａさんの2026年分の所得税における医療費控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが、妻Ｂさんの通院時に自家用車で送迎していた場合、その際にかかったガソリン代や駐車料金は、医療費控除の対象となる医療費の範囲に含まれます」",
        "choice2": "「Ａさんが2026年中に支払った医療費の総額が20万円を超えていない場合、医療費控除額は算出されません」",
        "choice3": "「Ａさんが妻Ｂさんの入院等に係る医療費について医療費控除の適用を受ける場合、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）の適用を受けることはできません」",
        "choice4": "",
        "choice5": "2025.05改",
        "categoryName": "タックス",
        "rontenName": "医療費控除",
        "important": ""
    },
    {
        "id": 70,
        "shikenId": 4,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/setsu_70.png'/>",
        "question2": "甲土地に耐火建築物を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "① 350㎡ ② 1,400㎡",
        "choice2": "① 400㎡ ② 1,400㎡",
        "choice3": "① 400㎡ ② 1,500㎡",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "不動産",
        "rontenName": "建蔽率、容積率",
        "important": ""
    },
    {
        "id": 71,
        "shikenId": 4,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/setsu_70.png'/>",
        "question2": "「被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例」（以下、「本特例」という）に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" src='/img/4_422.png' data-asset-id=\"a2faa581-7a4f-436d-badf-becdea311f18\">",
        "choice1": "①3,000　　②１億　　③３年",
        "choice2": "①3,000　　②6,000万　　③５年",
        "choice3": "①5,000　　②１億　　③５年",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "不動産",
        "rontenName": "空き家の譲渡所得の特例",
        "important": ""
    },
    {
        "id": 72,
        "shikenId": 4,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/setsu_70.png'/>",
        "question2": "事業用定期借地権方式に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「事業用定期借地権方式は、Ｘ社が甲土地を契約で一定期間賃借し、Ｘ社が甲土地上に店舗を建築する方式です。Ａさんは、土地を手放さずに安定した地代収入を得ることができ、契約期間満了時には土地が更地で返還されます」",
        "choice2": "「Ａさんが、甲土地についてＸ社と事業用定期借地権の設定契約を締結する場合、その契約は、公正証書によってしなければなりません」",
        "choice3": "「Ａさんと事業用定期借地権の設定契約を締結したＸ社が、甲土地上に店舗を建築し、その賃貸期間中にＡさんの相続が開始した場合、相続税額の計算上、甲土地は貸家建付地として評価されます」",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "不動産",
        "rontenName": "事業用定期借地権方式",
        "important": ""
    },
    {
        "id": 73,
        "shikenId": 4,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/setsu_73.png'/>",
        "question2": "自筆証書遺言に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「自筆証書遺言は、遺言者が、その遺言の全文、日付および氏名を自書し、これに押印して作成するものです。自筆証書に添付する財産目録については、パソコン等で作成することも認められています」",
        "choice2": "「相続人が自宅に保管されていた自筆証書遺言を発見した場合、相続人は、遅滞なく、自筆証書遺言を簡易裁判所に提出して、その検認を請求しなければなりません」",
        "choice3": "「自筆証書遺言の作成の際に押印する印鑑は、必ずしも実印である必要はなく、認印でも有効とされています」",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "相続",
        "rontenName": "自筆証書遺言に関する記述",
        "important": ""
    },
    {
        "id": 74,
        "shikenId": 4,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/setsu_73.png'/>",
        "question2": "仮に、Ａさんの相続が現時点で開始した場合の相続税等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Ｂさんが自宅の敷地と建物を相続により取得し、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、自宅の敷地（相続税評価額6,000万円）について、相続税の課税価格に算入すべき価額を4,800万円とすることができます」",
        "choice2": "「孫Ｆさんが相続により財産を取得した場合、孫Ｆさんは相続税額の２割加算の対象となります」",
        "choice3": "「遺言により相続財産の大半を妻Ｂさんおよび長男Ｃさんが相続した場合、孫Ｆさんの遺留分を侵害するおそれがあります。仮に、遺留分を算定するための財産の価額を２億4,000万円とした場合、孫Ｆさんの遺留分の金額は3,000万円となります」",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "相続",
        "rontenName": "相続税等に関する記述",
        "important": ""
    },
    {
        "id": 75,
        "shikenId": 4,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/setsu_73.png'/>",
        "question2": "仮に、Ａさんの相続が現時点で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が１億2,000万円であった場合の相続税の総額として、次のうち最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-id=\"27cfe6ab-db5a-423d-ba86-8165922eb0d4\" src='/img/4_15_1776230754963018.png' />",
        "choice1": "1,900万円",
        "choice2": "2,200万円",
        "choice3": "3,100万円",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "相続",
        "rontenName": "相続税の総額の計算",
        "important": ""
    },
    {
        "id": 76,
        "shikenId": 5,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/setsu_76.png'/>",
        "question2": "はじめに、Ｍさんは、《設例》の＜Ａさんとその家族に関する資料＞に基づき、Ａさんが老齢基礎年金の受給を65歳から開始した場合の年金額（2026年度価額）を試算した。Ｍさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "<img style='width:200px !important' data-image-id=\"I1\" data-asset-id=\"9e304155-d24d-4e7a-8c91-53dc1eb0c129\" src='/img/5_1_1776231075944310.png' />",
        "choice2": "<img style='width:200px !important' data-image-id=\"I2\" data-asset-id=\"c37b408d-d710-4310-8203-299c3583900f\" src='/img/5_1_1776231076995355.png' />",
        "choice3": "<img style='width:200px !important' data-image-id=\"I3\" data-asset-id=\"43c45142-4610-4584-8092-604bac870e71\" src='/img/5_1_1776231077231392.png' />",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の年金額",
        "important": ""
    },
    {
        "id": 77,
        "shikenId": 5,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/setsu_76.png'/>",
        "question2": "次に、Ｍさんは、Ａさんおよび妻Ｂさんが受給することができる公的年金制度からの老齢給付について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんおよび妻Ｂさんには、特別支給の老齢厚生年金の支給はありません。原則として、65歳から老齢基礎年金および老齢厚生年金を受給することになります」",
        "choice2": "「Ａさんが65歳から受給することができる老齢厚生年金の額には、妻Ｂさんが65歳になるまでの間、配偶者の加給年金額が加算されます」",
        "choice3": "「Ａさんが60歳０カ月で老齢基礎年金および老齢厚生年金の繰上げ支給を請求した場合、年金の減額率は30％となります」",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "ライフ",
        "rontenName": "公的年金制度の老齢給付",
        "important": ""
    },
    {
        "id": 78,
        "shikenId": 5,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/setsu_76.png'/>",
        "question2": "最後に、Ｍさんは、国民年金の学生納付特例制度（以下、「本制度」という）について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-id=\"d690591e-bd0a-424d-b754-68b80a269591\" src='/img/5_3_1776231077368476.png' />",
        "choice1": "① 世帯主　② 受給資格期間に算入　③ ５",
        "choice2": "① 学生本人　② 受給資格期間に算入　③ 10",
        "choice3": "① 世帯主　② 年金額に反映　③ 10",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "ライフ",
        "rontenName": "学生納付特例制度",
        "important": ""
    },
    {
        "id": 79,
        "shikenId": 5,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/setsu_79.png'/>",
        "question2": "はじめに、Ｍさんは、生命保険の見直しを検討するにあたって、現時点の必要保障額を試算することにした。下記の＜算式＞および＜条件＞に基づき、Ａさんが現時点で死亡した場合の必要保障額は、次のうちどれか。<br><img data-image-id=\"I1\" data-asset-id=\"ef398df7-0233-48f6-9b0e-29b569c89755\" src='/img/5_4_1776231078062343.png' /><br><img data-image-id=\"I2\" data-asset-id=\"55adcee3-0d81-42a3-a514-2747397dc70b\" src='/img/5_4_1776231078307598.png' />",
        "choice1": "200万円",
        "choice2": "300万円",
        "choice3": "700万円",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "リスク",
        "rontenName": "必要保障額の計算",
        "important": ""
    },
    {
        "id": 80,
        "shikenId": 5,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/setsu_79.png'/>",
        "question2": "次に、Ｍさんは、生命保険の見直しについてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も適切なものはどれか。",
        "choice1": "「厚生労働省の患者調査等の各種データによれば、入院日数は年々長期化しており、退院後の通院時の療養に係る費用負担も大きくなっていますので、医療保障を検討する場合は、入院や退院後の通院に対する保障を充実させることが大切です」",
        "choice2": "「介護保障を検討する際には、保険金額に加え、保険金等の支払事由が保険会社独自のものか、公的介護保険等の社会保障制度と連動しているものか等、どのような場合に保険金や給付金が支払われるか、加入前に確認しておきましょう」",
        "choice3": "「現在加入している生命保険を払済終身保険に変更した場合、死亡保険金額は減少しますが、現在付加されている入院特約は残り、月々の保険料負担は軽減されます」",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "リスク",
        "rontenName": "生命保険の見直し",
        "important": ""
    },
    {
        "id": 81,
        "shikenId": 5,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/setsu_79.png'/>",
        "question2": "最後に、Ｍさんは、ＡさんがＸ社を退職した後の健康保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんは、退職日の翌日から最長２年間、健康保険に任意継続被保険者として加入することができますが、保険料はＡさんが全額負担することになります」",
        "choice2": "「Ａさんが健康保険の任意継続被保険者とならなかった場合は、国民健康保険に加入します。Ａさんが国民健康保険に加入した場合、妻Ｂさんを国民健康保険の被扶養者とすることができます」",
        "choice3": "「Ａさんが国民健康保険に加入した場合、高額療養費の支給はありません。健康保険の任意継続被保険者には高額療養費の支給がありますので、退職後は、健康保険の任意継続被保険者になることをお勧めします」",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "リスク",
        "rontenName": "退職後の健康保険",
        "important": ""
    },
    {
        "id": 82,
        "shikenId": 5,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/setsu_82.png'/>",
        "question2": "仮に、Ｘ社がＡさんに役員退職金5,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を30年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "1,750万円",
        "choice2": "3,500万円",
        "choice3": "3,800万円",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "リスク",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 83,
        "shikenId": 5,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/setsu_82.png'/>",
        "question2": "Ｍさんは、《設例》の長期平準定期保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「当該生命保険の単純返戻率（解約返戻金額÷払込保険料累計額）は、保険期間の途中でピーク時期を迎え、その後は低下しますが、保険期間満了時に満期保険金が支払われます」",
        "choice2": "「現時点で当該生命保険を払済終身保険に変更する場合、契約は継続するため、経理処理は必要ありません」",
        "choice3": "「当該生命保険を払済終身保険に変更し、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義を変更することで、当該払済終身保険を役員退職金の一部としてＡさんに現物支給することができます」",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "リスク",
        "rontenName": "長期平準定期保険",
        "important": ""
    },
    {
        "id": 84,
        "shikenId": 5,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/setsu_82.png'/>",
        "question2": "Ｘ社が現在加入している《設例》の長期平準定期保険を下記＜条件＞にて解約した場合の経理処理（仕訳）として、次のうち最も適切なものはどれか。<br>＜条件＞<br>・Ｘ社が解約時までに支払った保険料の累計額は、5,200万円である。<br>・解約返戻金の額は、4,200万円である。<br>・配当等、上記以外の条件は考慮しないものとする。",
        "choice1": "<img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"9a5fe49c-aa9f-4e38-a888-f525398771ea\" src='/img/5_9_1776231078630804.png'>",
        "choice2": "<img data-image-id=\"I2\"  data-asset-scope=\"data_check\" data-asset-id=\"d759ef68-4681-4248-b95d-f88ef2459756\" src='/img/5_9_1776231078860582.png'>",
        "choice3": "<img data-image-id=\"I3\"  data-asset-scope=\"data_check\" data-asset-id=\"e1420073-7e14-4cf2-b169-05bbb26c1d51\" src='/img/5_9_1776231079025836.png'>",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "リスク",
        "rontenName": "長期平準定期保険の経理処理",
        "important": ""
    },
    {
        "id": 85,
        "shikenId": 5,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/setsu_85.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額として、次のうち最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-id=\"05de196f-9dc4-4fe1-911d-43db1128a11a\" src='/img/5_10_1776231079139804.png' />",
        "choice1": "580万円",
        "choice2": "610万円",
        "choice3": "770万円",
        "choice4": "",
        "choice5": "2024.05改",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 86,
        "shikenId": 5,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/setsu_85.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Ｂさんの給与収入の金額が62万円を超えていますので、Ａさんは配偶者控除の適用を受けることができません」",
        "choice2": "「Ａさんの合計所得金額は2,350万円以下ですので、Ａさんが適用を受けることができる基礎控除の控除額は62万円となります」",
        "choice3": "「長男Ｃさんは一般の控除対象扶養親族に該当するため、Ａさんは、長男Ｃさんについて38万円の扶養控除の適用を受けることができます」",
        "choice4": "",
        "choice5": "2024.05改",
        "categoryName": "タックス",
        "rontenName": "所得控除に関する記述",
        "important": ""
    },
    {
        "id": 87,
        "shikenId": 5,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/setsu_85.png'/>",
        "question2": "住宅借入金等特別控除に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><br>「Ａさんの場合、本年分の所得税における住宅借入金等特別控除の控除額は、『住宅ローンの年末残高×（ ① ）％』の算式により算出し、住宅借入金等特別控除の控除期間は、最長で（ ② ）年間となります。<br>Ａさんが本年分の所得税において住宅借入金等特別控除の適用を受けるためには、所得税の確定申告を行う必要があります。確定申告書の提出期限は、原則として、翌年（ ③ ）です」",
        "choice1": "① 0.7 ② 13 ③ ３月15日",
        "choice2": "① 1.0 ② 13 ③ ３月31日",
        "choice3": "① 1.0 ② 10 ③ ３月15日",
        "choice4": "",
        "choice5": "2024.05改",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 88,
        "shikenId": 5,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/setsu_88.png'/>",
        "question2": "仮に、Ａさんの相続が現時点で開始した場合の相続税等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんの相続における相続税額の計算上、遺産に係る基礎控除額は4,800万円になります」",
        "choice2": "「孫Ｅさんおよび孫Ｆさんが相続または遺贈により財産を取得した場合、相続税額の計算上、いずれも相続税額の２割加算の対象となります」",
        "choice3": "「Ａさんの相続が開始した場合、相続人は、Ａさんが作成した公正証書遺言について、家庭裁判所に検認の請求を行う必要があります」",
        "choice4": "",
        "choice5": "2025.05",
        "categoryName": "相続",
        "rontenName": "相続税等に関する記述",
        "important": ""
    },
    {
        "id": 89,
        "shikenId": 5,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/setsu_88.png'/>",
        "question2": "仮に、Ａさんの相続が現時点で開始した場合の「小規模宅地等についての相続税の課税価格の計算の特例」（以下、「本特例」という）に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><br>「妻Ｂさんが取得する自宅の敷地の全部について、特定居住用宅地等として本特例の適用を受けた場合、自宅の敷地（相続税評価額6,000万円）について、相続税の課税価格に算入すべき価額を（ ① ）万円とすることができます。<br>一方、長男Ｃさんが取得する賃貸アパートの敷地の全部について、貸付事業用宅地等として本特例の適用を受けた場合、賃貸アパートの敷地（相続税評価額4,500万円）について、相続税の課税価格に算入すべき価額を（ ② ）万円とすることができます。<br>なお、自宅の敷地と賃貸アパートの敷地の両方について本特例の適用を受けようとする場合、適用対象面積の調整をする必要（ ③ ）」",
        "choice1": "① 1,200　　② 900　　③ はありません",
        "choice2": "① 1,200　　② 2,250　　③ があります",
        "choice3": "① 4,800　　② 2,250　　③ はありません",
        "choice4": "",
        "choice5": "2025.05",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 90,
        "shikenId": 5,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/setsu_88.png'/>",
        "question2": "仮に、Ａさんの相続が現時点で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が１億8,000万円であった場合の相続税の総額として、次のうち最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-id=\"e11fc98d-b5c4-4d10-99eb-d01d7269755c\" src='/img/5_15_1776231079468206.png' />",
        "choice1": "1,400万円",
        "choice2": "3,400万円",
        "choice3": "5,500万円",
        "choice4": "",
        "choice5": "2025.05",
        "categoryName": "相続",
        "rontenName": "相続税の総額の計算",
        "important": ""
    },
    {
        "id": 91,
        "shikenId": 6,
        "no": 1,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を順守することが重要である。<br>ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "生命保険募集人、保険仲立人の登録を受けていないＦＰが、生命保険契約を検討している顧客のライフプランに基づき、必要保障額を具体的に試算し、相談料金を受け取った。",
        "choice2": "投資助言・代理業の登録を受けていないＦＰが、顧客と投資顧問契約を締結し、当該契約に基づいて具体的な投資銘柄と投資タイミングについて有償で助言をした。",
        "choice3": "税理士資格を有していないＦＰが、相続対策を検討している顧客に対し、一般的な相続税制度の仕組みと手順を解説し、相談料金を受け取った。",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "ライフ",
        "rontenName": "FPと関連業法",
        "important": ""
    },
    {
        "id": 92,
        "shikenId": 6,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記は、山岸家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）～（ウ）にあてはまる数値として、誤っているものはどれか。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用し、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"bd9062a9-a196-47f6-a2a3-afa10fa1a372\" src='/img/6_2_1776850201927947.png'><br>※年齢および金融資産残高は各年１２月３１日現在のものとし、２ＸＸ２年を基準年とする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。<br>※問題作成の都合上、一部を空欄にしてある。",
        "question2": "",
        "choice1": "（ア）４０２",
        "choice2": "（イ）６１",
        "choice3": "（ウ）１,２２０",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 93,
        "shikenId": 6,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "藤原家の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく藤原家のバランスシートの空欄（ア）にあてはまる金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"02e82b0c-0458-487c-91ee-f45ab9167a07\" src='/img/6_3_1776850202787116.png'><br>",
        "question2": "",
        "choice1": "１,２２０（万円）",
        "choice2": "１,９２０（万円）",
        "choice3": "１,９６０（万円）",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "ライフ",
        "rontenName": "バランスシート",
        "important": ""
    },
    {
        "id": 94,
        "shikenId": 6,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "藤原さんは、６０歳で定年を迎えた後、公的年金の支給が始まる６５歳までの５年間の生活資金に退職一時金の一部を充てようと考えている。仮に、退職一時金のうち６００万円を年利１.０％で複利運用しながら５年間で均等に取り崩すこととした場合、毎年の生活資金に充てることができる最大金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては万円未満を切り捨てること。また、税金や記載のない事項については一切考慮しないこととする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"df720677-c7d7-40bc-b61e-3509287f7921\" src='/img/6_4_1776850203535501.png'>",
        "question2": "",
        "choice1": "１１４万円",
        "choice2": "１１７万円",
        "choice3": "１２３万円",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "ライフ",
        "rontenName": "係数の計算",
        "important": ""
    },
    {
        "id": 95,
        "shikenId": 6,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "藤原健吾さん（４６歳：会社員）は、妻の恵子さん（４５歳：専業主婦）と長女の詩音さん（１９歳：大学生）と３人で暮らしている。健吾さんの公的年金加入歴は下記のとおりである。仮に、健吾さんが現時点（４６歳）で死亡した場合、健吾さんの死亡時点において妻の恵子さんに支給される公的年金の遺族給付に関する次の記述のうち、最も適切なものはどれか。なお、健吾さんは、入社時（２２歳）から死亡時まで厚生年金保険に加入しているものとし、遺族給付における生計維持要件は満たされているものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"b7c5ef97-18ba-431e-8880-ef73f8975790\" src='/img/6_5_1776850203947632.png'>",
        "question2": "",
        "choice1": "遺族基礎年金と中高齢寡婦加算額が加算された遺族厚生年金が支給される。",
        "choice2": "遺族厚生年金と寡婦年金が支給される。",
        "choice3": "中高齢寡婦加算額が加算された遺族厚生年金が支給される。",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "ライフ",
        "rontenName": "公的年金の遺族給付",
        "important": ""
    },
    {
        "id": 96,
        "shikenId": 6,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記＜資料＞に基づくＱＸ株式会社の投資指標に関する次の記述のうち、最も適切なものはどれか。<br>なお、購入時の手数料および税金は考慮しないこととする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"9b320916-db9e-467e-83af-d41525be5d27\" src='/img/6_6_1776850204294261.png'>",
        "question2": "",
        "choice1": "株価収益率（ＰＥＲ）で比較した場合、ＱＸ株式会社の株価は日経平均採用銘柄の平均（予想ベース）より割安である。",
        "choice2": "株価純資産倍率（ＰＢＲ）で比較した場合、ＱＸ株式会社の株価は東証プライム全銘柄の平均より割安である。",
        "choice3": "配当利回りで比較した場合、ＱＸ株式会社の配当利回りは東証スタンダード全銘柄の平均（予想ベース）より低い。",
        "choice4": "",
        "choice5": "2022.01",
        "categoryName": "金融",
        "rontenName": "投資指標",
        "important": ""
    },
    {
        "id": 97,
        "shikenId": 6,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記＜資料＞の外貨定期預金について、満期時の外貨ベースの元利合計額を円転した金額として、正しいものはどれか。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。また、税金については考慮しないこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"eb743bc4-ad49-42c9-9f78-ed8a9638f40b\" src='/img/6_7_1776850204913478.png'>",
        "question2": "",
        "choice1": "７８２,５０５円",
        "choice2": "７７７,４８３円",
        "choice3": "７７２,４６０円",
        "choice4": "",
        "choice5": "2022.05",
        "categoryName": "金融",
        "rontenName": "外貨預金元利金の計算",
        "important": ""
    },
    {
        "id": 98,
        "shikenId": 6,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "露木さんは、投資信託の費用についてＦＰの中井さんに質問をした。下記の空欄（ア）～（ウ）にあてはまる語句に関する次の記述のうち、最も適切なものはどれか。<img data-asset-scope=\"data_check\" data-asset-id=\"23540700-3686-45f2-a040-ef40609d881e\" src='/img/6_8_1776850205476529.png'>",
        "question2": "",
        "choice1": "（ア）にあてはまる語句は、「オープン」である。",
        "choice2": "（イ）にあてはまる語句は、「口座管理料」である。",
        "choice3": "（ウ）にあてはまる語句は、「信託財産留保額」である。",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "金融",
        "rontenName": "投資信託のコスト",
        "important": ""
    },
    {
        "id": 99,
        "shikenId": 6,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "建築基準法に従い、下記＜資料＞の土地に建築物を建築する場合、その土地に対する建築物の建築面積の最高限度として、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"39572d59-d8c0-444c-8725-45bb40ff0e9d\" src='/img/6_9_1776850206280928.png'>",
        "question2": "",
        "choice1": "２４０㎡",
        "choice2": "３６０㎡",
        "choice3": "４８０㎡",
        "choice4": "",
        "choice5": "2022.05",
        "categoryName": "不動産",
        "rontenName": "建築物の建築面積",
        "important": ""
    },
    {
        "id": 100,
        "shikenId": 6,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "下記は、宅地建物の売買・交換において、宅地建物取引業者と交わす媒介契約の種類とその概要についてまとめた表である。下表の空欄（ア）～（ウ）にあてはまる語句または数値の組み合わせとして、正しいものはどれか。なお、自己発見取引とは、自ら発見した相手方と売買または交換の契約を締結する行為を指すものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"c2e70847-309a-44c2-baee-95599086d93b\" src='/img/6_10_1776850206941812.png'>",
        "question2": "",
        "choice1": "（ア）可  （イ）２週間 （ウ）５",
        "choice2": "（ア）可  （イ）１ヵ月 （ウ）７",
        "choice3": "（ア）不可 （イ）１ヵ月 （ウ）５",
        "choice4": "",
        "choice5": "2021.09",
        "categoryName": "不動産",
        "rontenName": "媒介契約",
        "important": ""
    },
    {
        "id": 101,
        "shikenId": 6,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "土地の登記記録に関する下表の空欄（ア）～（ウ）にあてはまる記録事項の組み合わせとして、最も適切なものはどれか。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"59872e7f-468b-4f24-a95e-4b6f333e62ce\" src='/img/6_11_1776850207561077.png'>",
        "question2": "",
        "choice1": "（ア）所有権保存登記  （イ）賃借権設定登記 （ウ）抵当権設定登記",
        "choice2": "（ア）土地の所在や地積 （イ）賃借権設定登記 （ウ）抵当権設定登記",
        "choice3": "（ア）土地の所在や地積 （イ）所有権移転登記 （ウ）賃借権設定登記",
        "choice4": "",
        "choice5": "2025.05",
        "categoryName": "不動産",
        "rontenName": "土地の登記記録",
        "important": ""
    },
    {
        "id": 102,
        "shikenId": 6,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "飯田雅彦さんが加入している定期保険特約付終身保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しており、特約は自動更新されているものとする。また、雅彦さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"c4923f0d-7a2f-4d4a-b35d-7073c846c013\" src='/img/6_12_1776850207965313.png'><br><br><img data-image-id=\"I2\"  data-asset-scope=\"content_extraction\" data-asset-id=\"61c2cd79-1ff4-482d-beb1-f600cfbd537f\" src='/img/6_12_1776850209015080.png'>",
        "question2": "",
        "choice1": "３,５００万円",
        "choice2": "３,９００万円",
        "choice3": "４,２００万円",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "リスク",
        "rontenName": "生命保険証券の見方",
        "important": ""
    },
    {
        "id": 103,
        "shikenId": 6,
        "no": 13,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "会社員の大久保さんが加入している生命保険について、死亡保険金が一時金として支払われた場合の課税関係に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "保険契約者（保険料負担者）および被保険者が大久保さん、死亡保険金受取人が大久保さんの妻の場合、妻が受け取った死亡保険金は贈与税の課税対象となる。",
        "choice2": "保険契約者（保険料負担者）が大久保さん、被保険者が大久保さんの妻、死亡保険金受取人が大久保さんの場合、大久保さんが受け取った死亡保険金は所得税・住民税の課税対象となる。",
        "choice3": "保険契約者（保険料負担者）が大久保さん、被保険者が大久保さんの妻、死亡保険金受取人が大久保さんの子の場合、子が受け取った死亡保険金は相続税の課税対象となる。",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "リスク",
        "rontenName": "死亡保険金の課税関係",
        "important": ""
    },
    {
        "id": 104,
        "shikenId": 6,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "細井英治さんが契約している自動車保険の主な内容は、下記＜資料＞のとおりである。＜資料＞に基づく次の記述のうち、自動車保険による補償の対象とならないものはどれか。なお、いずれも保険期間中に発生したものであり、被保険自動車の運転者は英治さんである。また、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"53be3dbe-1d6b-4ee4-89d6-b98d30beccca\" src='/img/6_14_1776850209418423.png'>",
        "question2": "",
        "choice1": "被保険自動車を運転中に、ブレーキ操作を誤り単独事故を起こし、車体が損傷した場合の修理費用",
        "choice2": "被保険自動車に追突した相手車が逃走し、相手から損害賠償金が受けられない場合の英治さんの治療費用",
        "choice3": "被保険自動車を運転中に、誤って自宅のブロック塀を損壊した場合のブロック塀の修理費用",
        "choice4": "",
        "choice5": "2022.05",
        "categoryName": "リスク",
        "rontenName": "自動車保険の補償",
        "important": ""
    },
    {
        "id": 105,
        "shikenId": 6,
        "no": 15,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "会社員の細川博さんが本年中に支払った医療費等が下記＜資料＞のとおりである場合、博さんの本年分の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、博さんの本年中の所得は、給与所得６００万円のみであり、支払った医療費等はすべて博さんおよび生計を一にする妻のために支払ったものである。また、保険金等により補てんされた金額はないものとし、医療費控除の金額が最も大きくなるよう計算することとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"871d7e1a-ad6a-4c68-a2de-395aeb0b526c\" src='/img/6_15_1776850209980255.png'>",
        "question2": "",
        "choice1": "３２０,０００円",
        "choice2": "１７０,０００円",
        "choice3": "１５０,０００円",
        "choice4": "",
        "choice5": "2022.01",
        "categoryName": "タックス",
        "rontenName": "医療費控除",
        "important": ""
    },
    {
        "id": 106,
        "shikenId": 6,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "高橋さんは、当年３月に下記＜資料＞の一時払養老保険の満期保険金を受け取った。高橋さんが当年分の所得税において総所得金額に算入すべき一時所得の金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"26a7cd79-a892-4604-a993-4b8b38044bc2\" src='/img/6_16_1776850210540460.png' style='width:400px !important'>",
        "question2": "",
        "choice1": "５０万円",
        "choice2": "７５万円",
        "choice3": "１００万円",
        "choice4": "",
        "choice5": "2025.05",
        "categoryName": "タックス",
        "rontenName": "総所得金額に算入すべき一時所得の金額",
        "important": ""
    },
    {
        "id": 107,
        "shikenId": 6,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記＜資料＞に基づき、目黒昭雄さんの当年分の所得税を計算する際の所得控除に関する次の記述のうち、最も適切なものはどれか。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"6c170178-e289-4233-ab6b-903d14b5d959\" src='/img/6_17_1776850211000919.png'><br>※当年１２月３１日時点のデータである。<br>※家族は全員、昭雄さんと同居し、生計を一にしている。<br>※障害者または特別障害者に該当する者はいない。",
        "question2": "",
        "choice1": "妻の聡美さんは控除対象配偶者となり、昭雄さんは３８万円を控除することができる。",
        "choice2": "長男の幸一さんは特定扶養親族となり、昭雄さんは６３万円を控除することができる。",
        "choice3": "二男の浩二さんは一般の扶養親族となり、昭雄さんは３８万円を控除することができる。",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 108,
        "shikenId": 6,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "相続が開始された皆川健太郎さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"3e4626d8-2141-4398-87b8-a63cd6fed5aa\" src='/img/6_18_1776850211514316.png'>",
        "question2": "",
        "choice1": "美千子 ２／３　　喜美子 １／３",
        "choice2": "美千子 １／２　　喜美子 １／２",
        "choice3": "美千子 １／２　　莉緒 １／２",
        "choice4": "",
        "choice5": "2023.01",
        "categoryName": "相続",
        "rontenName": "法定相続分",
        "important": ""
    },
    {
        "id": 109,
        "shikenId": 6,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "相続開始後の各種手続きにおける下記＜資料＞の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"870ad90a-ea52-4f1c-b53c-9ff36cdbf8b6\" src='/img/6_19_1776850212336866.png'>",
        "question2": "",
        "choice1": "（ア）地方裁判所 （イ） ６ヵ月",
        "choice2": "（ア）地方裁判所 （イ）１０ヵ月",
        "choice3": "（ア）家庭裁判所 （イ）１０ヵ月",
        "choice4": "",
        "choice5": "2023.01",
        "categoryName": "相続",
        "rontenName": "相続放棄、相続税の申告期限",
        "important": ""
    },
    {
        "id": 110,
        "shikenId": 6,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "福岡明雄さんは、妻から居住用不動産の贈与を受けた。明雄さんは、この居住用不動産の贈与について、贈与税の配偶者控除の適用を受けることを検討しており、ＦＰで税理士でもある木内さんに相談をした。この相談に対する木内さんの回答の空欄（ア）、（イ）にあてはまる数値の組み合わせとして、正しいものはどれか。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"199fa7c9-5c35-46a2-8961-aaffe61de80f\" src='/img/6_20_1776850212933016.png'>",
        "question2": "",
        "choice1": "（ア）１,０００ （イ）１０",
        "choice2": "（ア）２,０００ （イ）１０",
        "choice3": "（ア）２,０００ （イ）２０",
        "choice4": "",
        "choice5": "2022.05",
        "categoryName": "相続",
        "rontenName": "贈与税の配偶者控除",
        "important": ""
    }
]